var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.isCustomerAdmin)?_c('DashboardCustomer'):(_vm.isAdmin)?_c('DashboardAdmin'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }